module.exports = __webpack_public_path__ + "img/storage.6acb5091.svg";